<template>
  <div class="row">
    <div class="footer-top-icon" :class="{'hidden-xs hidden-sm':isShowWeb}">
      <div class="top-icon-one start">
        <div class="icon-one-left start">
          <div class="icon-one-tips">{{lanType==1?'发起单位:':'Co-Founders:'}}</div>
          <div class="icon-one-li spaceBetween">
            <!-- <img src="@/images/opflogo.png" alt="#" class="footer-icon-img" /> -->
            <img src="@/images/logo7.png" alt="#" class="footer-icon-img"/>
            <img src="@/images/logo8.png" alt="#" class="footer-icon-img" style="margin-left: 0;"/>
            <!-- <img src="@/images/logo3.png" alt="#" class="footer-icon-img" /> -->
            <!-- <img src="@/images/logo2.png" alt="#" class="footer-icon-img" style="margin-left: 0;"/>
            <img src="@/images/team.png" alt="#" class="footer-icon-img" style="margin-left: 0;"/> -->
          </div>
        </div>
        <div class="icon-one-line"></div>
        <div class="icon-one-right end">
          <div class="icon-one-tips">{{lanType==1?'合作伙伴:':'Partners:'}}</div>
          <div class="icon-one-li spaceBetween">
            <img src="@/images/logo2.png" alt="#" class="footer-icon-img" style="width:auto;"/>
            <img src="@/images/team.png" alt="#" class="footer-icon-img" style="width:auto;"/>
            <img src="@/images/logo4.png" alt="#" class="footer-icon-img" style="width:auto;"/>
            <img src="@/images/logo5.png" alt="#" class="footer-icon-img" style="width:auto;margin-left: 0;"/>
            <!-- <img src="@/images/logo6.png" alt="#" class="footer-icon-img" style="width:auto;margin-left: 0;"/> -->
            <img src="@/images/esi.png" alt="#" class="footer-icon-img" style="width:auto;margin-left: 0;"/>
          </div>
        </div>
      </div>
      <!-- <img src="@/images/opflogo.png" alt="#" class="footer-icon-img" /> -->
      <div class="top-icon-right" style="padding:0.25rem 0;">
        <div class="icon-right-top start">
          <div class="right-top-list"><a href="https://www.wwfchina.org/about?id=40&type=1" target="_blank">{{lanType==1?'隐私政策':'Privacy'}}</a></div>
          <div class="right-top-list"><a href="https://www.opfngo.org.cn/" target="_blank">{{lanType==1?'OPF官网':'OPF'}}</a></div>
          <div class="right-top-list"><a href="http://www.wwfchina.org/" target="_blank">{{lanType==1?'WWF中国官网':'WWF China'}}</a></div>
          <div class="right-top-list"><a href="https://sciencebasedtargets.org/" target="_blank">{{lanType==1?'SBTi官网':'SBTi'}}</a></div>
        </div>
        <div class="icon-right-bottom ">© 2025 ClimateBusinessHub 版权所有 ICP证：<a href="https://beian.miit.gov.cn/" target="_blank" style="color:#2c3e50">京ICP备17064567号-3</a></div>
      </div>
    </div>

    <div class="phone-footer-icon hidden-md hidden-lg" v-if="isShowWeb">
      <div class="phone-one-tips">{{lanType==1?'发起单位:':'Sponsor:'}}</div>
      <img src="@/images/logo7.png" alt="#" class="phone-icon-img" />
      <img src="@/images/logo8.png" alt="#" class="phone-icon-img" />
      <!-- <img src="@/images/logo3.png" alt="#" class="phone-icon-img" /> -->
      <!-- <img src="@/images/team.png" alt="#" class="phone-icon-img" /> -->
      <div class="phone-one-tips">{{lanType==1?'合作伙伴:':'Partners:'}}</div>
      <img src="@/images/logo2.png" alt="#" class="phone-icon-img"/>
      <img src="@/images/team.png" alt="#" class="phone-icon-img"/>
      <img src="@/images/logo4.png" alt="#" class="phone-icon-img" />
      <img src="@/images/logo5.png" alt="#" class="phone-icon-img" />
      <img src="@/images/esi.png" alt="#" class="phone-icon-img"/>
      <div class="phone-right-top middle">
        <div class="phone-top-list"><a href="http://www.wwfchina.org/privacy.php" target="_blank">{{lanType==1?'隐私政策':'Privacy'}}</a></div>
        <div class="phone-top-list"><a href="http://www.wwfchina.org/" target="_blank">{{lanType==1?'WWF中国官网':'WWF China'}}</a></div>
        <div class="phone-top-list"><a href="https://www.opfngo.org.cn/" target="_blank">{{lanType==1?'OPF官网':'OPF'}}</a></div>
        <div class="phone-top-list"><a href="https://sciencebasedtargets.org/" target="_blank">{{lanType==1?'SBTi官网':'SBTi'}}</a></div>
      </div>

      <div class="phone-right-bottom">© 2025 ClimateBusinessHub 版权所有 ICP证：<a href="https://beian.miit.gov.cn/" target="_blank" style="color:#2c3e50">京ICP备17064567号-3</a></div>
    </div>
  </div>
</template>

<script>
import config from '@/utils/config';
export default {
  name: 'footerBar',
  data () {
    return {
      isShowWeb:config.urlList.isShowWeb,
      lanType:1
    }
  },
  methods:{
    
    goEarth(url){
      window.open(url)
    },
    choiceType(type){
      const vm=this
      vm.lanType=type
    },
    goPage(id){
      const vm=this
      vm.$router.push({ path:'/mechanism',query:{id:id,type:1}  })
    },
  },
  computed: {
    
  }
}
</script>

<style scoped>
.footer-top-icon{
  margin-top: 0.75rem;
  padding: 0 0.5rem;
}
.top-icon-one{
  font-size: 0.125rem;
  color: #000000;
  font-weight: 600;
}
.icon-one-left{
  width: auto;
  height: auto;
}
.icon-one-right{
  flex: 2;
  height: auto;
}
.icon-one-tips{
  width: 0.6rem;
  height: auto;
  min-width: 0.5rem;
}
.icon-one-li{
  flex: 2;
}
.footer-icon-img{
  margin: 0 0.15rem;
  width: auto;
  height: 0.36rem;
}
.icon-one-line{
  width: 1px;
  height: 0.2rem;
  margin: 0 0.15rem;
  background: #000;
}
.right-top-list{
  /* width: 0.725rem; */
  width: auto;
  height: 0.175rem;
  font-size: 0.125rem;
  color: #000000;
  text-align: center;
  line-height: 0.175rem;
  border-left: 1px solid #000;
  font-family: 'wwf';
  text-align: right;
  /* margin-left: 0.375rem; */
  padding: 0 0.186rem;
  cursor: pointer;
}
.right-top-list:nth-child(1){
  border-left: none;
  /* margin-left: 0; */
  text-align: left;
  width: auto;
  padding-left: 0;
}
.icon-right-bottom{
  font-size: 0.0875rem;
  text-align: left;
  margin-top: 0.125rem;
}


/****/
.phone-footer-icon{
  margin-top: 1.467rem;
  padding: 0 0.5rem;
}
.phone-one-tips{
  font-size: 0.42rem;
  font-weight: 600;
  color: #000;
  margin-bottom: 0.64rem;
}
.phone-icon-img{
  width: 4.57rem;
  height: auto;
  margin-bottom: 0.32rem;
}
.phone-right-top{
  margin-top: 0.8rem;
  width: 100%;
  height: auto;
}
.phone-top-list{
  flex: 2;
  height: 0.373rem;
  font-size: 0.32rem;
  line-height: 1;
  border-left: 1px solid #000;
  color: #333;
  font-family: 'wwf';
}
.phone-top-list:nth-child(1){
  border-left: none;
}
.phone-right-bottom{
  font-size: 0.267rem;
  color: #666;
  margin-top: 0.5rem;
  text-align: center;
}

.phone-footer-font{
  font-size: 0.4rem;
  color: #000;
  margin-top: 0.48rem;
  font-weight: 500;
}
.phone-bottom-li{
  font-size: 0.4rem;
  color: #000;
  font-weight: 600;
  margin-top: 1.2rem;
}
.phone-right-img{
  width: 0.907rem;
  height: 0.907rem;
  margin: 0.56rem 0.56rem 0;
}
.phone-footer-list{
  padding: 0 0.667rem;
}
.phone-footer-li{
  padding: 0 0.62rem;
  font-size: 0.26rem;
  color: #000;
  font-weight: 600;
  border-right: 1px solid #666;
  margin-top: 1.2rem;
}
.phone-footer-li:nth-child(1){
  padding-left: 0;
  padding-right: 0.4rem; 
}
.phone-footer-li:nth-child(2){
  padding: 0 0.56rem;
}
.phone-footer-li:nth-child(3){
  padding: 0 0.56rem;
}
.phone-footer-li:nth-child(4){
  padding-left: 0.56rem;
  padding-right: 0; 
  border-right: none;
}
.phone-footer-li:last-child{
  border-right: none;
}
.phone-font-tips{
  color: #000;
  font-size: 0.32rem;
  margin-bottom: 0.32rem;
}
</style>
